import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as feedAdviceActions from '../store/feed-advice.actions';

@Injectable()
export class FeedAdviceOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(feedAdviceActions.loadData());
    return of(true);
  }
}
